/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import _ from 'lodash';
import Loadable from 'react-loadable';
import { Grid, Paper, ListItemSecondaryAction } from '@material-ui/core';
import atoms from 'ctsutheme/components/atoms';
import molecules from 'ctsutheme/components/molecules';
import { withStyles } from '@material-ui/core/styles';
import { protocolRoutes } from 'routes/appRoutes';
import { FasTimes } from 'assets/icons';
import { NoMatch, CTSULoadingSpinner } from 'components';
import { TE } from 'appconstants';
import { Link } from 'react-router-dom';
import { CanUserViewSection } from 'appconstants/Permission';
import { RenderElement } from 'components/RenderHelpers';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const { Typography, IconButton } = atoms;
const { List, ListSubHeader } = molecules;

const styles = theme => ({
  root: {},
  grdItem: {
    margin: 10,
    height: 100,
    minWidth: 200,
    float: 'center',
    borderRadius: '8px',
    cursor: 'pointer',
    backgroundColor: theme.palette.primary.light
  },
  text: {
    color: 'white',
    textAlign: 'center',
    paddingTop: '25px'
  }
});
const LoadablePrtCmp = ({ type }) => {
  const LoadableComponent = Loadable({
    // eslint-disable-next-line prefer-template
    loader: () => import('containers/protocol' + type),
    ErrorComponent: () => <NoMatch />,
    loading: () => <CTSULoadingSpinner />
  });
  return <LoadableComponent />;
};

const PrtTileContent = props => {
  const [state, setState] = useState({ selected: false, type: '', name: '' });
  const { classes } = props;
  return (
    <Typography>
      {!state.selected ? (
        <Grid
          container
          spacing={0}
          justify="center"
          className={classes.root}
        >
          {protocolRoutes.map(prtRoute => (
            <RenderElement access={CanUserViewSection(prtRoute.permission)}>
              <Link
                item
                key={_.uniqueId('protocol_tile')}
                className="protocol-graphic-tiles"
                onClick={() => setState({
                  ...state,
                  selected: !state.selected,
                  type: prtRoute.path,
                  name: prtRoute.name
                })}
              >
                <Paper className={classes.grdItem}>
                  <div data-id={`${TE.ID}tile_content${TE.DIV}`} className={classes.text}>
                    <prtRoute.icon />
                    <br />
                    {prtRoute.name === 'Details' ? 'Protocol Details' : prtRoute.name}
                  </div>
                </Paper>
              </Link>
            </RenderElement>
          ))}
        </Grid>
      ) : (
        <List
          subheader={(
            <ListSubHeader flex className="split-screen-content-page-title">
              <Typography data-id={`${TE.ID}tile_header${TE.LBL}`} primary header>
                {state.name}
              </Typography>
              <ListItemSecondaryAction>
                <Typography link icon>
                  <IconButton
                    data-id={`${TE.ID}tile_section${TE.CLOSEBTN}`}
                    onClick={() => setState({
                      ...state,
                      selected: !state.selected
                    })}
                    className="fn-btn delete mr-n4"
                  >
                    <FasTimes />
                  </IconButton>
                </Typography>
              </ListItemSecondaryAction>
            </ListSubHeader>
          )}
        >
          <LoadablePrtCmp type={state.type} />
        </List>
      )}
    </Typography>
  );
};

const withConnectState = connect(
  (state, ownProps) => ({}),
  dispatch => bindActionCreators(
    {},
    dispatch
  )
);

export const ProtocolTileContent = withConnectState(withStyles(styles)(PrtTileContent));
